import { GlobalSchemaFields } from '@/api/mongooseTypes';

export async function listQA(api, params) {
  return (await api.get('rml/admin/qas', { params })).data;
}

export async function readQA(api, id, params) {
  return (await api.get(`rml/admin/qas/${id}`, { params })).data;
}

export async function createQA(api, payload) {
  return (await api.post('rml/admin/qas', payload)).data;
}

export async function updateQA(api, id, payload) {
  return (await api.patch(`rml/admin/qas/${id}`, payload)).data;
}

export async function deleteQA(api, id) {
  return (await api.delete(`rml/admin/qas/${id}`)).data;
}

export class IQA extends GlobalSchemaFields {
  question;
  answer;
  order;
  enabled;

  constructor(obj) {
    super(obj);
    Object.assign(this, obj);
  }
}
